import { create } from 'zustand';

type ModalStore = {
  isModalOpen: boolean;
  toggleModal: (state: boolean) => void;
};

const useModalStore = create<ModalStore>((set) => ({
  isModalOpen: false,
  toggleModal: (state: boolean) => set({ isModalOpen: state }),
}));

export { useModalStore };
